// JavaScript Document

/* Brand List */
function awardli(callback,append){
var awardlist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/award2025/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){

if(json[i].url_o1800){
    awardlist = '<li><img src="' + json[i].img + '" alt="' + json[i].name1 + '"><div class="pmark">' + json[i].prefecture + '</div><p>' + json[i].name1 + '</p><a href="' + json[i].url_o720 + '" target="_top"><div class="btn720">商品はこちら</div></a><a href="' + json[i].url_o1800 + '" target="_top"><div class="btn1800">1800mlはこちら</div></a></li>';
} else {
    awardlist = '<li><img src="' + json[i].img + '" alt="' + json[i].name1 + '"><div class="pmark">' + json[i].prefecture + '</div><p>' + json[i].name1 + '</p><a href="' + json[i].url_o720 + '" target="_top"><div class="btn720">商品はこちら</div></a></li>';
}

/*				if(json[i].url != ""){
					awardlist = '<li><a href="' + json[i].url_o + '" target="_top">' + '<img src="' + json[i].img + '" alt="' + json[i].name + '"><div><img src="' + json[i].logo + '" alt="' + json[i].name + '"></div><p>' + json[i].cap + '</p></a></li>';
				}*/
   				$(append).append(awardlist);
   			}
		}
    })
};